import Typography from 'antd/lib/typography';

const { Title } = Typography;

const Testimonials = () => {
  return (
    <div className="py-5">
      <Title level={2} className="text-center mb-4">Nuestros clientes opinan</Title>
      <blockquote className="blockquote text-center">
        <p className="mb-0">“Excelente servicio, rápido y confiable. Me llegó el paquete en solo 4 días.”</p>
        <footer className="blockquote-footer mt-2">María G., <cite title="Managua">Managua</cite></footer>
      </blockquote>
    </div>
  );
};

export default Testimonials;